export enum CollectionItemTypes {
  Ulds = 0,
  Nets = 1,
  GalleyCarts = 2,
  Dollys = 3,
  OnAssetBLETags = 50,
}

export enum CollectionMethod {
  ScanAndManualEntry = 0,
  Bluetooth = 1,
}
